import DOMPurify from 'dompurify'

/**
 * 사용자 입력·서버 유래 HTML 을 DOM 삽입 전에 소독한다.
 *
 * DBE Keeper 설계 §5 위험 #3 (XSS → IndexedDB 디바이스 키 악용) 완화책.
 * dangerouslySetInnerHTML 사용처는 반드시 이 함수를 거칠 것 —
 * CSP(unsafe-inline 허용 보수안)가 막지 못하는 inline 주입을 여기서 차단한다.
 *
 * USE_PROFILES.html: 표준 HTML 만 허용 (svg/mathml 벡터 차단).
 */
const sanitizeHtml = (html) => DOMPurify.sanitize(html, { USE_PROFILES: { html: true } })

export default sanitizeHtml
